import React, { memo } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { InputProps3 } from "./types";
import useStyles from "./styles.css";
import { colors } from "theme";
import _ from "lodash";

function TextInput03(props: InputProps3) {
  const styles = useStyles();
  const { label, error } = props;
  const errLabelStyle = error ? { color: colors.red } : {};
  const errBorderStyle: any = error && { borderColor: colors.red };

  return (
    <View style={[styles.marginTop20, props.style]}>
      <View style={styles.v_label}>
        {!!label && (
          <Text style={[styles.label, props.labelStyle, errLabelStyle]}>
            {props.label}
          </Text>
        )}
        {_.isEmpty(error) ? null : (
          <Text style={[styles.txtError]}>{error}</Text>
        )}
      </View>
      <TouchableOpacity
        activeOpacity={1}
        onPress={props.onPress}
        disabled={!props.editable}
        style={[styles.t3_border, props.borderStyle, errBorderStyle]}
      >
        <View>
          <Text
            style={[
              styles.t_input, props.description && { fontWeight: "bold" },
              !props.value && { color: colors.placeholder },
              props.inputStyle,
            ]}
          >
            {props.value || props.placeholder}
          </Text>
          {props.description &&
            <Text
              style={[
                styles.t_input_description,
                !props.description && { color: colors.placeholder },
                props.inputStyle,
              ]}
            >
              {props.description}
            </Text>
          }
        </View>
        
        {typeof props.renderIcon === "function" && props.renderIcon(props)}
      </TouchableOpacity>
    </View>
  );
}

export default memo(TextInput03);
